var maps = [];

$(document).ready(function() {

    var didScroll;
    var lastScrollTop = 0;
    var delta = 200;
    var navbarHeight = $('#head').outerHeight();

    $(window).scroll(function(event){
          didScroll = true;
     });

     setInterval(function() {
          if (didScroll) {
              hasScrolled();
              didScroll = false;
          }
      }, 250);


  if($( window ).width() > 528){
      str = '<video playsinline="playsinline" autoplay="autoplay" loop="true" muted="muted"><source src="'+$('#header .video').attr('data-src-mp4')+'" type="video/mp4"><source src="'+$('#header .video').attr('data-src-webm')+'" type="video/webm"></video>';
      $('#header').addClass('isVideo');
      $('#header .video').html(str);
  }else{
      $('#header .video').removeClass('isVideo');
      $('#header .video').html('');
  }

   $('.lazy').show().lazy();

   $('input').iCheck({
     checkboxClass: 'icheckbox_square',
     radioClass: 'iradio_square',
     increaseArea: '20%' // optional
   });

   $('.photogalery, .photos').magnificPopup({
       type: 'image',
       delegate: 'a',
       gallery: {
           enabled: true
       }
   });

  $("#news .col").click(function(){
       window.location=$(this).find("a").attr("href");
       return false;
  });

  $("#head .mobileNav").click(function(){
      if($('#head ul').hasClass('active')){
          $("#head .mobileNav i").removeClass('icon-cross').addClass('icon-menu');
          $('#head ul').removeClass('active');
          $('body').removeClass('locked');
      }else{
          $("#head .mobileNav i").addClass('icon-cross').removeClass('icon-menu');
          $('#head ul').addClass('active');
          $('body').addClass('locked');
      }
  });

  $( ".form input,.form textarea" ).focusin(function() {
      $(this).closest('li').addClass('focus');
  });

  $( ".form input,.form textarea" ).focusout(function() {
      val = $(this).val();
      if(val == ''){
          $(this).closest('li').removeClass('focus');
      }
  });
  $('.form button').click(function(){
      $('.form .gform_footer input[type="submit"]').click();
  });

  $('a.jumpTo').click(function(){
      target = $(this).attr('data-target');
      $('html, body').animate({
                    scrollTop: $('#'+target).offset().top
                }, 1000);
  })

  $('a.modal-btn').click(function(){
      $('#modal').addClass('active');
  });

  $('#modal a.closeModal').click(function(){
      $('#modal').removeClass('active');
  });

  $('.accordion-item').click(function(){
      if($(this).hasClass('active')){
          $('.accordion-item.active').find('.hid').slideToggle(400);
          $('.accordion-item.active').removeClass('active');
      }else{
          $('.accordion-item.active').find('.hid').slideToggle(400);
          $('.accordion-item.active').removeClass('active');
          $(this).addClass('active').find('.hid').slideToggle(400);
          obj  = $(this);

          setTimeout(function(){
              $('html, body').animate({
                            scrollTop: (obj.offset().top-100)
                        }, 1000);
           }, 500);
      }


  });

  if($('body').has('.ajaxLoadNews')){
      $.getScript( url+"/scripts/pager.js", function( data, textStatus, jqxhr ) {

      });
  }


  if($('body').find('.gform_confirmation_message').length > 0){
      $('.submit').hide();
      if($('body').find('#modal').length > 0){
          $('#modal').addClass('active');
      }
  }
  if($('body').find('.validation_error').length > 0){
      $( ".form #gform_fields_1 li" ).each(function() {
          if($(this).find('input[type="text"]').length > 0){
              val = $(this).find('input[type="text"]').val().length;
              if(val > 0){
                  $(this).addClass('focus');
              }
          }
          if($(this).find('textarea').length > 0){
              val = $(this).find('textarea').val().length;
              if(val > 0){
                  $(this).addClass('focus');
              }
          }
      });
  }

  renderMaps();
});

function renderMaps(){
    if($( "body" ).has( "#map" )){



        $.getScript( url+"/scripts/leaflet.js", function( data, textStatus, jqxhr ) {
            var LeafIcon = L.Icon.extend({
                options: {
                    iconSize:     [140, 50],
                    iconAnchor:   [140, 25]
                }
            });
            var icons  = new LeafIcon({iconUrl: url+'/img/map.svg'});
            $( ".maps" ).each(function( index ) {
                obj  = $( this );
                zoom = 8;
                if($(this).attr('data-zoom') != '')  zoom = parseInt($(this).attr('data-zoom'));
                lat  = parseFloat($(this).attr('data-lat'));
                lng  = parseFloat($(this).attr('data-lng'));
                if(lat != '' && lng != ''){
                    map = L.map($(this).attr('id'),{scrollWheelZoom: false}).setView([lat, lng], zoom);
                    maps.push(map);
                    L.tileLayer('https://api.tiles.mapbox.com/v4/{id}/{z}/{x}/{y}.png?access_token={accessToken}', {
                        maxZoom: 18,
                        id: 'mapbox.streets',
                        accessToken: 'pk.eyJ1Ijoicm9jZXNtYW5pYyIsImEiOiJjam5hb2NzazQyZWxoM2tydWd0OHN5OThkIn0.2kz8ZH1-HH-TkOh1anDHDA'
                    }).addTo(maps[index]);

                    L.marker([lat, lng], {icon: icons}).addTo(maps[index]);
                }
            });

        });
    }
}

function hasScrolled() {
   var scrollTop = $(this).scrollTop();

   if(scrollTop > 0){
       if(!$('#head').hasClass('fixed')){
           $('#head').addClass('fixed');
       }
   }else{
      if($('#head').hasClass('fixed')){
          $('#head').removeClass('fixed');
      }
   }
}
